import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import Button from "./Button";
import { useToast } from "./Toast";
const AddClinic = ({ open, onClose,doctorId }) => {
    const Toast = useToast();
  const [clinicDetails, setClinicDetails] = useState({
    clinicName: "",
    clinicAddress: "",
  });
  const [errors, setErrors] = useState({
    clinicName: "",
    clinicAddress: "",
  });
  const handleKioskChange = (e) => {
    const { name, value } = e.target;
    setClinicDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  const token = localStorage.getItem("token");
  const handleSave = async () => {
    setErrors({
      clinicName: "",
      clinicAddress: "",
    });

    let valid = true;
    const newErrors = {};

    // Validation
    if (!clinicDetails.clinicName) {
      newErrors.clinicName = "Clinic Name is required";
      valid = false;
    }

    if (!clinicDetails.clinicAddress) {
      newErrors.clinicAddress = "Address is required";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST_URL}/ops/v1/clinic/create`,
          {
            clinic: {
              name: clinicDetails.clinicName,
              address: clinicDetails.clinicAddress,
              // Add other kiosk details as needed
            },
            doctorId: doctorId, // Replace with actual clinicId
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
       
        Toast.success("clinic added... ");
        onClose();   
      } catch (error) {
        console.error(
          "Error creating Clinic:",
          error.response ? error.response.data : error.message
        );
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: "bold" }}>Add New Clinic</DialogTitle>
      <DialogContent>
        <Box>
          <Typography variant="h6" gutterBottom>
            Clinic Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Clinic Name"
                name="clinicName"
                value={clinicDetails.clinicName}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.clinicName}
                helperText={errors.clinicName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Address"
                name="clinicAddress"
                value={clinicDetails.clinicAddress}
                onChange={handleKioskChange}
                fullWidth
                error={!!errors.clinicAddress}
                helperText={errors.clinicAddress}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "center", gap: "2px" }}
      >
        <Button
          backgroundColor="#CCD3DA"
          color="#000"
          hoverColor="#A9A9A9"
          text="Cancel"
          width="150px"
          onClick={onClose}
        />
        <Button text="Save" width="150px" onClick={handleSave} />
      </DialogActions>
    </Dialog>
  );
};

export default AddClinic;
